<label class="custom-radio">
    <input type="radio" name="radio" [value]="value" [checked]="checked" />
    <span [class]="classes"></span>
    {{ label }}
</label>